import AboutContent from '../components/about/AboutContent';
import AboutHead from "../components/about/AboutHead";

export default function About() {
  return (
    <>
      <AboutHead />
      <AboutContent />
    </>
  );
}